import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  makeStyles,
} from "@fluentui/react-components";
import { useTagCollectionWithTagsGet } from "../../hooks/useTagCollections";
import { ArrowDownloadFilled } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

interface ExportTagsDialogProps {
  tagCollectionId: string;
}
const useStyles = makeStyles({
  triggerButton: {
    height: "33px",
    marginLeft: "8px",
    marginBottom: "5px",
  },
});

export const ExportTagsDialog = (props: ExportTagsDialogProps) => {
  const { tagCollectionId } = props;

  const classes = useStyles();
  const { t } = useTranslation();

  const { data: tagCollection, isLoading: tagsLoading } =
    useTagCollectionWithTagsGet(tagCollectionId);

  const downloadTags = () => {
    if (!tagCollection || tagsLoading) {
      return;
    }

    const serializedTags = `data:text/json;chatset=utf-8,${encodeURIComponent(
      JSON.stringify(tagCollection)
    )}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = serializedTags;
    downloadLink.download = `${tagCollection.title}.json`;

    downloadLink.click();
  };

  return (
    <Dialog>
      <DialogTrigger disableButtonEnhancement>
        <Button
          icon={<ArrowDownloadFilled />}
          className={classes.triggerButton}
        >
          {t("export")}
        </Button>
      </DialogTrigger>
      <DialogSurface aria-describedby={undefined}>
        <DialogBody>
          <DialogTitle> {t("exportTagCollection")}</DialogTitle>
          <DialogContent>{t("exportDownloadPrompt")}</DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">{t("close")}</Button>
            </DialogTrigger>
            <DialogTrigger disableButtonEnhancement>
              <Button
                appearance="primary"
                disabled={tagsLoading}
                onClick={downloadTags}
              >
                {t("download")}
              </Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
